import React, { useState, useCallback, useEffect } from 'react'
import RightModal from '../Modals/RightModal';
import { companyService } from '../../services/company'
import { guideServices } from '../../services/guides';

const UploadModal = ({ closeModal, show, getGuides, editGuideItem, isEdit }) => {

    const [name, setName] = useState('');
    const [thumbnailUrl, setThumbnilUrl] = useState('');
    const [pdfUrl, setPDFUrl] = useState('');
    const [pdfSizeExceedError, setPdfSizeExceedError] = useState(false);
    const [thumbnailSizeExceedError, setThumbnailSizeExceedError] = useState(false);
    const [pdfTypeError, setPDFTypeError] = useState(false);
    const [imageTypeError, setImageTypeError] = useState(false);

    // const [image, setImage] = useState({
    //     filepath: '',
    //     file: null
    // })

    useEffect(() => {
        if (isEdit && editGuideItem) {
            setName(editGuideItem.name);
            setThumbnilUrl(editGuideItem.thumbnail);
            setPDFUrl(editGuideItem.file_url)
        }
    }, [editGuideItem, isEdit])

    const handelThumbnail = async (event) => {

        if (event.target.files[0]) {
            console.log(event.target.files[0].type)
            if ((event.target.files[0].type !== "image/png") && (event.target.files[0].type !== "image/jpeg")) {
                setImageTypeError(true);
                return
            } else {
                setImageTypeError(false)
            }
            if (event.target.files[0].size / 1048576 > 3) {
                setThumbnailSizeExceedError(true);
                return;
            } else {
                setThumbnailSizeExceedError(false);
            }
            const formData = new FormData();
            formData.append("file", event.target.files[0])
            const url = await companyService.uploadFile(formData)
            if (url.data.status === 200) {
                setThumbnilUrl(url.data.data.s3_url)
            }
        }
    }

    const handlePDFChange = async (event) => {
        if (event.target.files[0]) {
            if (event.target.files[0].type !== 'application/pdf') {
                setPDFTypeError(true);
                return
            } else {
                setPDFTypeError(false)
            }
            if (event.target.files[0].size / 1048576 > 10) {
                setPdfSizeExceedError(true);
                return;
            } else {
                setPdfSizeExceedError(false);
            }
            const formData = new FormData();
            formData.append("file", event.target.files[0])
            const url = await companyService.uploadFile(formData)
            if (url.data.status === 200) {
                setPDFUrl(url.data.data.s3_url)
            }

        }

    }

    const handleSubmit = async () => {
        const payload = {
            name: name,
            thumbnail: thumbnailUrl,
            file_url: pdfUrl
        }
        const res = await guideServices.insertNewGuide(payload);
        if (res.data.status === 200) {
            getGuides();
            closeModal();
        }
    }

    const handleEditSave = async () => {
        const payload = {
            name: name,
            thumbnail: thumbnailUrl,
            file_url: pdfUrl
        }
        const res = await guideServices.update(editGuideItem.uuid, payload);
        if (res.data.status === 200) {
            getGuides();
            closeModal();
        }
    }

    const handlesubmit = () => {
        // uploadGuides
        console.log(handlesubmit)
    }
    console.log(handlesubmit)

    return (
        <RightModal closeModal={closeModal} show={show}>
            <div className="modal-header sticky top-0 left-0 bg-white !px-5  !py-4 flex">
                <h1 className='text-black text-2xl inter m-0'>Upload Guide</h1>
                <button onClick={closeModal} className='modal-close'> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M13.4115 12.0003L18.6886 17.2822C19.079 17.6729 19.0787 18.306 18.688 18.6964C18.2973 19.0867 17.6641 19.0864 17.2738 18.6957L11.9963 13.4135L6.70658 18.6953C6.31577 19.0856 5.6826 19.0851 5.29237 18.6943C4.90213 18.3035 4.9026 17.6703 5.29342 17.2801L10.5827 11.9986L5.29565 6.70679C4.9053 6.31609 4.90559 5.68292 5.29629 5.29257C5.68699 4.90223 6.32016 4.90251 6.7105 5.29321L11.998 10.5855L17.2739 5.31734C17.6648 4.92711 18.2979 4.92758 18.6881 5.31839C19.0784 5.70921 19.0779 6.34237 18.6871 6.73261L13.4115 12.0003Z" fill="#171725" />
                </svg></button>
            </div>

            <div className="modal-body !px-5 h-5/6 overflow-y-auto space-y-4">
                <div className="">
                    <label className="block text-14 text-black700 mb-2">Name</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder='Guide name'
                        className="w-full px-3 py-2.5 bg-black100 border border-black200 rounded-md text-14 placeholder-black600 focus:outline-none focus:border-primary focus:ring-primary invalid:border-pink-500 invalid:text-pink-600  focus:invalid:border-pink-500 focus:invalid:ring-pink-500"
                    />
                </div>

                <div className="">
                    <span className="block text-14 text-black700 mb-2">Upload Pdf File</span>
                    <input
                        onChange={handlePDFChange}
                        type='file'
                        accept="application/pdf"
                        className="w-full px-3 py-2.5 bg-black100 border border-black200 rounded-md text-14 placeholder-black
                            focus:outline-none focus:border-primary focus:ring-primary invalid:border-pink-500 invalid:text-pink-600  focus:invalid:border-pink-500 focus:invalid:ring-pink-500"
                    />
                    {pdfSizeExceedError && <p className='text-14 text-red mb-0'>Pdf can not exceed 10 mb</p>}
                    {pdfTypeError && <p className='text-14 text-red mb-0'>File should be pdf format</p>}
                </div>

                <div className="">
                    <span className="block text-14 text-black700 mb-2">Thumbnail</span>
                    <input
                        onChange={handelThumbnail}
                        type='file'
                        accept="image/png, image/jpeg"
                        className="w-full px-3 py-2.5 bg-black100 border border-black200 rounded-md text-14 placeholder-black
                            focus:outline-none focus:border-primary focus:ring-primary invalid:border-pink-500 invalid:text-pink-600  focus:invalid:border-pink-500 focus:invalid:ring-pink-500"
                    />
                    {thumbnailSizeExceedError && <p className='text-14 text-red mb-0'>Thumbnail can not exceed 3 mb</p>}
                    {imageTypeError && <p className='text-14 text-red mb-0'>Thumbnail should be jpg or png format.</p>}
                </div>

                {/* <div className="uploadblock block">
                    <div className='uploadarea w-full h-60 border border-black400 rounded border-dotted flex items-center justify-center flex-col relative'
                    draggable="true"
                    onDrop={handleDrop}
                    onDragLeave={handleDrag}
                    onDragOver={handleDrag}
                    >
                        <input onChange={handelThumbnail} type="file" className=' opacity-0' />
                        {
                            image.filepath ? <p className='mb-2 fz14 font-medium text-black700'></p>
                                : <p className='mb-2 fz14 font-medium text-black700'>Drag & Drop file</p>
                        }
                        <button className='flex items-center bg-primary rounded text-white py-1.5 fz14 font-medium px-3'><svg className='mr-1' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><mask id="path-1-inside-1_2043_354" fill="white"><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z"></path></mask><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white"></path><path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_2043_354)"></path></svg> Upload File</button>
                    </div>
                </div> */}
                {thumbnailUrl && <div className=''>
                    <div className='grid grid-cols-2 gap-4 gap-x-2 space-x-2'>
                        <div>
                            {/* <span className="block text-14 text-black700 mb-2">Thumbnail</span> */}
                            <div className="bg-black100 border rounded border-black200 h-32 w-rull">
                                {thumbnailUrl && <img className="object-scale-down h-32 w-full" src={thumbnailUrl} />}
                            </div>
                        </div>
                        {/* <div>
                            <span className="block text-14 text-black700 mb-2">PDf</span>
                            <div className="bg-black100 border rounded border-black200 h-32 w-full">
                                <img className="object-scale-down" />
                            </div>
                        </div> */}
                    </div>
                </div>}


            </div>
            <div className="d-flex flex-row align-items-center justify-content-between !px-5 gap-x-4 !py-4 righmodalfooter shadow-topshadow">
                <button onClick={closeModal} className='border rounded-lg py-2.5 w-28 basis-28 grow-0 shrink-0 border-primary !text-primary font-semibold text-16 text-center'>Cancel</button>
                <button onClick={() => {
                    if (!isEdit) {
                        handleSubmit()
                    } else {
                        handleEditSave()
                    }
                }} className='border rounded-lg py-2.5 w-full ml-4 !bg-primary border-primary text-white font-semibold text-16 text-center hover:opacity-90'>Save</button>

            </div >
        </RightModal >
    )
}

export default UploadModal
